// extracted by mini-css-extract-plugin
export default {"column":"Bar_column__AA4L8","barre":"Bar_barre__9uP6U","last":"Bar_last__eN7UX"};